import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white text-gray-900">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4"><strong>Effective Date:</strong> 6th October 2025</p>

      <p className="mb-4">
        At <strong>Harmiton WebTech</strong> ("we," "our," or "us"), your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you visit our website <a href="https://harmiton.in" className="text-blue-600 underline">harmiton.in</a> or use our services.
      </p>
      <p className="mb-6">By using our website, you agree to the terms of this Privacy Policy.</p>

      <h2 className="text-2xl font-semibold mb-4">Information We Collect</h2>
      <h3 className="font-semibold mb-2">Personal Information You Provide:</h3>
      <p className="mb-4">
        We collect personal data that you voluntarily submit through our contact forms, including:
      </p>
      <ul className="list-disc list-inside mb-6">
        <li>Full Name</li>
        <li>Company Name</li>
        <li>Email Address</li>
        <li>Phone Number</li>
        <li>Message or inquiry details</li>
      </ul>

      <h3 className="font-semibold mb-2">Automatically Collected Information:</h3>
      <p className="mb-6">
        When you visit our website, we may also collect certain technical data automatically such as:
      </p>
      <ul className="list-disc list-inside mb-6">
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Operating system</li>
        <li>Pages visited and time spent</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">How We Use Your Information</h2>
      <p className="mb-6">
        We use your information to:
      </p>
      <ul className="list-disc list-inside mb-6">
        <li>Respond to your inquiries and provide customer support</li>
        <li>Improve our website and services</li>
        <li>Send important updates or service-related messages (only if you have consented)</li>
        <li>Comply with legal obligations</li>
      </ul>
      <p className="mb-6">We do <strong>not</strong> sell, rent, or share your personal data with third parties for marketing purposes.</p>

      <h2 className="text-2xl font-semibold mb-4">Cookies and Tracking Technologies</h2>
      <p className="mb-6">
        We use cookies to improve your experience on our site and to analyze site usage. You can control cookie preferences in your browser settings, but disabling cookies may affect site functionality.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Data Security</h2>
      <p className="mb-6">
        We implement reasonable technical and organizational measures to protect your data from unauthorized access, loss, or misuse.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Data Retention</h2>
      <p className="mb-6">
        We retain your personal information only as long as necessary to respond to your inquiries or as required by law.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Your Rights (Including GDPR)</h2>
      <p className="mb-6">
        Depending on your location, you have the right to:
      </p>
      <ul className="list-disc list-inside mb-6">
        <li>Access your personal data</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your personal data</li>
        <li>Restrict or object to data processing</li>
        <li>Withdraw consent where applicable</li>
        <li>Request transfer of your data (data portability)</li>
      </ul>
      <p className="mb-6">
        To exercise any of these rights, please contact us at <a href="mailto:harmitonwt@gmail.com" className="text-blue-600 underline">harmitonwt@gmail.com</a>.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Children’s Privacy</h2>
      <p className="mb-6">
        Our services are not directed to children under 18. We do not knowingly collect personal data from children.
      </p>

      <h2 className="text-2xl font-semibold mb-4">International Data Transfers</h2>
      <p className="mb-6">
        If you are located outside of India, please note your data may be transferred to and processed in India. We ensure appropriate safeguards are in place to protect your information.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Changes to This Privacy Policy</h2>
      <p className="mb-6">
        We may update this policy periodically. The updated version will be posted here with a revised effective date.
      </p>

      <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
      <p>
        If you have questions or concerns about this Privacy Policy, please contact us:
      </p>
      <ul className="list-disc list-inside">
        <li>Email: <a href="mailto:harmitonwt@gmail.com" className="text-blue-600 underline">harmitonwt@gmail.com</a></li>
        <li>Phone: +91 8451985096</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
